
import { Toast } from 'antd-mobile';
import cover from '../../static/images/minCover.png';
import { ApiCore } from '../../api';
const api = new ApiCore();
const cachesImgMap = {};
export default function handlerCanvas(
    imgUrl,
    refCanvas,
    refEdit,
    refDelete,
    refRevert,
    refZoomIn,
    refZoomOut,
    refComplete,
    recognizeConfig,
    callBack
) {
    let _imgUrl = imgUrl.indexOf('?') > 0 ?  imgUrl.split('?')[0] : imgUrl;
    let canvas = refCanvas;
    let editBtn = refEdit;
    let deleteImageBtn = refDelete;
    let revertBtn = refRevert;
    let zoomInBtn = refZoomIn;
    let zoomOutBtn = refZoomOut;
    let completeBtn = refComplete;
    let ctx = canvas.getContext('2d');
    let refDrawCanvas = refCanvas.parentNode;
    let minWidth = refDrawCanvas.offsetWidth // window.screen.width; // 屏幕宽度
    let minHeight = refDrawCanvas.offsetHeight ; // 按比例计算铺满横屏的图片高度
    let image = new Image();
    let imageRect = new Image();
    let layers = []; // 图层
    let canvasRect = canvas.getBoundingClientRect();
    let pattern; // 脱敏图案
    let isRecognize = recognizeConfig.isRecognize;
    let isOcr = recognizeConfig.isOcr;
    let isEditPhoto = recognizeConfig.isEditPhoto;
    let sensitiveInitData = recognizeConfig.sensitiveData || [];
    let sensitiveDatas = [];
    let sensitiveArealdy = false;
    let recognizeInitData = recognizeConfig.reconizeData.coordinate || [];
    let recognizeDatas = [];
    let recognizedArealdy = false;
    let lastClicked = false; //是否上次点击过
    let imgData = recognizeConfig.imgData || {};
    let formCode = recognizeConfig.formCode;
    let version = recognizeConfig.version || '1.0';
    let needOcrRecongize = recognizeConfig.needOcrRecongize;
    let recognizeInterval = null;
    let sensitiveInterval = null;
    let scrollElement = canvas.parentNode; // 滚动元素
    const _itemData = {
        projectCode: '',
        subjectCode: ''
    };
    let itemData = sessionStorage.getItem('toPhotoEditItem');
    itemData = itemData ? JSON.parse(itemData) : _itemData;
    // 标注
    let recognizeData = [{
        type: 1, // 绿色
        beginX: 20,
        beginY: 20,
        endX: 60,
        endY: 60,
        index: 1
    }, {
        type: 1, // 绿色
        beginX: 100,
        beginY: 60,
        endX: 150,
        endY: 100,
        index: 2
    }];
    // 敏感信息
    let sensitiveData = [

    {
        type: 3, // 橙色
        beginX: 187,
        beginY: 507,
        endX: 306,
        endY: 539,
        index: 4
    }
    ]; // 识别标注
    canvas.addEventListener("touchstart", touchStart);
    canvas.addEventListener("touchmove", touchMove);
    canvas.addEventListener("touchend", touchEnd);
    deleteImageBtn && deleteImageBtn.addEventListener("click", toDeleteImage);
    editBtn && editBtn.addEventListener("click", editRect);
    zoomInBtn && zoomInBtn.addEventListener("click", zoomInRect);
    zoomOutBtn && zoomOutBtn.addEventListener("click", zoomOutRect);
    revertBtn && revertBtn.addEventListener("click", revertRect);
    completeBtn && completeBtn.addEventListener("click", completeOperation);

    //画布横屏百分之百
    canvas.width = window.screen.width;
    // imgUrl = 'https://lechen.oss-cn-qingdao.aliyuncs.com/edc/data/TENANT-003/configjy/data_497eb12c30c440cca36028ad25b11a99.jpg';
    // 背景图片
    image.src = imgUrl;
    // 遮罩图片
    imageRect.src = cover;
    // 背景图片加载
    image.onload = function() {
        // 按比例设置横屏铺满的宽高
        canvas.height = minWidth * (image.height / image.width);
        minHeight = minWidth * (image.height / image.width);
        canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
        canvasRect = canvas.getBoundingClientRect();
        initCanvasPosition();
        initBackground();
        // 需设置延时，否则被框住的背景图片无法渲染出来
        // 初始OCR、敏感信息识别
        initMarkedArea();
    }
    
    imageRect.onload = function() {
        pattern = ctx.createPattern(imageRect, 'repeat');
    }
    let beginX = 0, // 拖动或绘制图片的起始坐标X
        beginY = 0; // 拖动或绘制图片的起始坐标Y
    let id = 0;
    let clickedIndex = -1; // 点击选中拖拽使用
    let selectIndex = -1; // 点击选中删除待用
    let moveX, // 拖动水平偏移量
        moveY; // 拖动垂直偏移量
    let ifEdit = false; // 是否可以脱敏
    const scaleStep = 1.25; // 每次放缩的倍数
    let perScaleStep = 0.25; // 每次递增放大以及缩小的倍数
    let realScaleStep = 1; // 实际的放大以及缩小的倍数
    let scale = 1; // 放缩比例

    // 初始化背景图
    function initBackground() {
        // 图片过大或者过小等比缩放
        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, minWidth,  minWidth * (image.height / image.width));
    }

    // 注意，往左边画交界矩形框，会影响，拖拽不出来
    function touchStart (event) {
        // if (ifEdit) {
        //     event.preventDefault();
        // } else {
        //     return;
        // }
        const touches = [].slice.call(event.touches);
        if (touches.length > 1) { // 多点触摸，不做处理
            return;
        }
        canvasRect = canvas.getBoundingClientRect();
        const target = touches[0];
        const x = (target.pageX - canvasRect.left) / scale;
        const y = (target.pageY - canvasRect.top) / scale;
        beginX = x;
        beginY = y;
        clickedIndex = -1; // 每次触摸重置
        selectIndex = -1; // 每次触摸重置
        dragedRectIndex(event);
    }
    
    function touchMove (event) {
        if (ifEdit) {
            // 禁止滑动时跟随滚动条滚动
            event.preventDefault();
        } else {
            return;
        }
        const touches = [].slice.call(event.touches);
        if (touches.length > 1) {
            return;
        }
        canvasRect = canvas.getBoundingClientRect();
        const target = touches[0];
        let x = (target.pageX - canvasRect.left) / scale;
        let y = (target.pageY - canvasRect.top) / scale;
        ctx.save();
        if (clickedIndex > -1) {
            // 选中矩形
            moveX = x - beginX;
            moveY = y - beginY;
            clearAllRect();
            drawAllRect({ moveX: moveX, moveY: moveY});
        } else {
            // 绘制新的矩形
            // 因为拉矩形往反方向拉，所以需要情况之前的，然后绘制最新的
            clearAllRect();
            drawAllRect({ moveX: 0, moveY: 0});
            drawRect(beginX, beginY, x - beginX, y - beginY);
        }
        ctx.restore();
    }
    
    function touchEnd (event) {
        canvasRect = canvas.getBoundingClientRect();
        let x = (event.changedTouches[0].pageX - canvasRect.left) / scale;
        let y = (event.changedTouches[0].pageY - canvasRect.top) / scale;
        let isClick = (beginX === x && beginY === y);
        let isSelected = (selectIndex > -1);
        // if (isClick) {
        //     // 点击事件，点击选中的浮层
        //     clearAllRect();
        //     drawAllRect({ moveX: moveX, moveY: moveY});
        //     const val = layers[selectIndex];
        //     drawRectAfterNumber(val.beginX - 1, val.beginY - 1, (val.endX - val.beginX + 2), (val.endY - val.beginY + 2), 2);
        //     callBack('showDeleteCoverBottom', 'show');
        // }
        if (ifEdit) {
            // 禁止滑动时跟随滚动条滚动
            event.preventDefault();
            // editBtn.classList.remove('breath');
            ifEdit = false; // 一次只能脱敏一次
        } else if (!isClick) {
            return;
        }
        // 选中矩形拖动结束，更新缓存中被选中元素的坐标
        if (clickedIndex > -1) {
            setDragRectPosition();
        }
        // 更新最新绘制的矩形
        if (((x - beginX) !== 0 && (y - beginY) !== 0) && (clickedIndex === -1)) {
            // 如果从右到左绘制的话，将坐标点设置为左上顶点、右下顶点
            // 以便于判断点击与选中区域，以及传入给后端
            let startX = Math.min(beginX, x);
            let startY = Math.min(beginY, y);
            let stopX = Math.max(beginX, x);
            let stopY = Math.max(beginY, y);
            layers.push({
                id: id++,
                beginX: startX,
                beginY: startY,
                endX: stopX,
                endY: stopY
            });
        }
        if (selectIndex === -1 && lastClicked) {
            lastClicked = false;
            clearAllRect();
            drawAllRect({ moveX: 0, moveY: 0});
            // 点其他区域隐藏取消，删除按钮
            callBack('showDeleteCoverBottom', 'hide');
        }
        // 点击事件，点击选中的浮层
        if (isClick && isSelected) {
            lastClicked = true;
            const val = layers[selectIndex];
            clearAllRect();
            drawAllRect({ moveX: 0, moveY: 0});
            ctx.strokeStyle = '#db8208';
            drawRectAfterNumber(val.beginX - 1, val.beginY - 1, (val.endX - val.beginX + 2), (val.endY - val.beginY + 2), '#db820'); // 橙色
            callBack('showDeleteCoverBottom', 'show');
        }
        callBack('editComplete');
        moveX = 0;
        moveY = 0;
        clickedIndex = -1;
    }

    function initCanvasPosition() {
        // 横屏铺满
        if (image.width >= image.height) {
            // 画布横屏父级元素百分之百
            // 满屏屏幕宽度图片对应的屏幕高度
            const fullScreenHeight = refDrawCanvas.offsetWidth * image.height / image.width;
            // 不能用clientWidth或者clientHeight,因为有轮播的情况会被挡住
            if (refDrawCanvas.offsetHeight >= fullScreenHeight) {
                // 横屏正好可以放进去
                minWidth = refDrawCanvas.offsetWidth;
                //画布横屏父级元素百分之百
                canvas.width = minWidth;
                // 按比例设置横屏铺满的宽高
                minHeight = minWidth * (image.height / image.width);
                canvas.height = minHeight;
                // 设置图片在居中的位置
                // parentElement
                canvas.style.marginLeft = '0px'; //  因为复用一张图片，重置状态
                canvas.style.marginTop = refDrawCanvas.offsetHeight / 2 - canvas.height / 2 + 'px';
                canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
            } else {
                // 图片宽度百分之百高度突出去
                minHeight = refDrawCanvas.offsetHeight;
                let fullScreenHeightToWidth = minHeight  * (image.width / image.height);
                minWidth = fullScreenHeightToWidth;
                canvas.width = minWidth;
                canvas.height = minHeight;
                // 设置图片在居中的位置
                // 不能如下设置，不然会滚动
                canvas.style.marginTop = '0px'; //  因为复用一张图片，重置状态
                canvas.style.marginLeft = refDrawCanvas.offsetWidth / 2 - canvas.width / 2 + 'px';
                canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
            }
        } else {
            // 满屏屏幕高度图片对应的屏幕宽度
            const fullScreenWidth = refDrawCanvas.offsetHeight * image.width / image.height;
            // 画布横屏父级元素百分之百
            if (refDrawCanvas.offsetWidth >= fullScreenWidth) {
                // 竖屏百分之百能放进去
                minHeight = refDrawCanvas.offsetHeight;
                canvas.height = minHeight;
                // 按比例设置横屏铺满的宽高
                minWidth = minHeight * (image.width / image.height);
                canvas.width = minWidth;
                canvas.style.marginTop = '0px'; //  因为复用一张图片，重置状态
                // 设置图片在居中的位置
                canvas.style.marginLeft = refDrawCanvas.offsetWidth / 2 - canvas.width / 2 + 'px';
                canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
            } else {
                // 竖屏百分之百，横屏图片超出
                minWidth = refDrawCanvas.offsetWidth;
                //画布横屏父级元素百分之百
                canvas.width = minWidth;
                // 按比例设置横屏铺满的宽高
                minHeight = minWidth * (image.height / image.width);
                canvas.height = minHeight;
                canvas.style.marginLeft = '0px'; //  因为复用一张图片，重置状态
                // 设置图片在居中的位置
                canvas.style.marginTop = refDrawCanvas.offsetHeight / 2 - canvas.height / 2 + 'px';
                canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
            }
        }
    }

    // 放大后超出屏幕按中心查看以及设置滚动
    function setScrollPositionCenter() {
        // 画布大小在矩形框内时
        if (canvas.width <= refDrawCanvas.offsetWidth && canvas.height <= refDrawCanvas.offsetHeight) {
            canvas.style.marginTop = refDrawCanvas.offsetHeight / 2 - canvas.height / 2 + 'px';
            canvas.style.marginLeft = refDrawCanvas.offsetWidth / 2 - canvas.width / 2 + 'px';
        // 横长方形
        } else if (image.width >= image.height) {
            // 放大后横向超出，竖直仍未超出（放大两次再缩小一次也是这样，下同）
            if (refDrawCanvas.offsetHeight >= canvas.height) {
                canvas.style.marginLeft = '0px';
                canvas.style.marginTop = refDrawCanvas.offsetHeight / 2 - canvas.height / 2 + 'px';
                canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
                scrollElement.scrollTo((canvas.width - minWidth) / 2, 0);
            } else {
                // 放大后横向超出，竖直也超出
                canvas.style.marginLeft = '0px';
                canvas.style.marginTop = '0px';
                canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
                scrollElement.scrollTo((canvas.width - refDrawCanvas.offsetWidth) / 2, (canvas.height - refDrawCanvas.offsetHeight) / 2); // 不能用min，因为可能没撑满
            }
        // 竖长方形
        } else {
            // 放大后竖直超出，横向仍未超出
            if (refDrawCanvas.offsetWidth >= canvas.width) {
                canvas.style.marginTop = '0px';
                canvas.style.marginLeft = refDrawCanvas.offsetWidth / 2 - canvas.width / 2 + 'px';
                canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
                scrollElement.scrollTo(0, (canvas.height - minHeight) / 2);
            } else {
                // 放大后竖直超出，横向仍也超出
                canvas.style.marginLeft = '0px';
                canvas.style.marginTop = '0px';
                canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
                scrollElement.scrollTo((canvas.width - refDrawCanvas.offsetWidth) / 2, (canvas.height - refDrawCanvas.offsetHeight) / 2); // 不能用min，因为可能没撑满
            }
        }
    }

    // 清除所有
    function resetAllCover() {
        clearAllRect();
        drawAllRect({ moveX: 0, moveY: 0});
    }

    // 提交数据时还原对应的坐标比例
    function resetRelativeRect(resetLayers) {
        const scaleable = resetLayers.map(val => {
            return {
                id: val.id,
                beginX: val.beginX * scale,
                beginY: val.beginY * scale,
                endX: val.endX * scale,
                endY: val.endY * scale
            };
        });
        return scaleable;
    }
    
    function drawRect(
        beginX,
        beginY,
        width,
        height
    ) {
        // 图片铺满
        // ctx.drawImage(imageRect, 0, 0, 202, 201, beginX, beginY, width, height);
        // ctx.strokeRect(beginX, beginY, width, height)
        ctx.fillStyle = pattern;
        ctx.fillRect(beginX, beginY, width, height);
    }
    
    // 判断点击的是否在选中输入框内
    // 坐标存储需从左边，因为可能是从右到左画的，从下到上画的。
    function dragedRectIndex (event) {
        const clickX = (event.touches[0].pageX - canvasRect.left) / scale;
        const clickY = (event.touches[0].pageY - canvasRect.top) / scale;
        layers.forEach((item, index) => {
            if ((clickX >= item.beginX && clickX <= item.endX)
             && (clickY >= item.beginY && clickY <= item.endY)) {
                clickedIndex = index;
                selectIndex = index;
            }
        });
    }
    
    // 重新绘制所有矩形
    function drawAllRect({ moveX, moveY }) {
        initBackground();
        isRecognize && drawMarkedNumberRect();
        layers.forEach((item, index) => {
            if (clickedIndex === index) {
                // 选中的矩形随着偏移量重新绘制以实现拖动效果
                drawRect(item.beginX + moveX, item.beginY + moveY, item.endX - item.beginX, item.endY - item.beginY);
            } else {
                drawRect(item.beginX, item.beginY, item.endX - item.beginX, item.endY - item.beginY);
            }
        });
    }
    
    // 更新缓存中选中的矩形坐标
    function setDragRectPosition() {
        const _moveX = moveX ? moveX : 0;
        const _moveY = moveY ? moveY : 0;
        layers.forEach((item, index) => {
            if (clickedIndex === index) {
                item.beginX = item.beginX + _moveX;
                item.beginY = item.beginY + _moveY;
                item.endX = item.endX + _moveX;
                item.endY = item.endY + _moveY;
            }
        });
    }
    
    // 清除所有矩形
    function clearAllRect() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
    
    // 点击删除
    function deleteSelectRect(event) {
        layers = layers.filter((val, index) => {
            return selectIndex !== index;
        })
        if (selectIndex > -1) {
            drawAllRect({ moveX: 0, moveY: 0});
        }
        selectIndex = -1;
    }

    // 删除图片
    function toDeleteImage() {
        callBack('toDeleteImage');
    }

    // 点击脱敏（此时可以绘制图片）
    function editRect(event) {
        ifEdit =!ifEdit;
        // ifEdit && editBtn.classList.add('breath');
        // !ifEdit && editBtn.classList.remove('breath');
        callBack('edit', ifEdit);
    }

    // 放大
    function zoomInRect(event) {
        realScaleStep += perScaleStep;
        // canvas.width *= scaleStep;
        // canvas.height *= scaleStep;
        canvas.width = minWidth * realScaleStep;
        canvas.height = minHeight * realScaleStep;
        scale = canvas.height / minHeight;
        ctx.scale(scale,scale);
        canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
        drawAllRect({ moveX: 0, moveY: 0});
        setScrollPositionCenter();
        callBack('zoomRatio', '当前比例&nbsp;&nbsp;&nbsp;' + realScaleStep * 100 + '%');
        // if (realScaleStep > 1) {
        //     const _scrollEl = document.querySelector('.image-canvas_main');
        //     // document.querySelector('.image-canvas_main').scrollBy(100, 0);
        //     _scrollEl && _scrollEl.scrollTo((canvas.width - minWidth) / 2, 0);
        // }
    }
    
    // 缩小
    function zoomOutRect(event) {
        if (realScaleStep <= 0.25) {
            Toast.show('不能缩放更小了', 1);
            return;
        }
        realScaleStep -= perScaleStep;
        // canvas.width /= scaleStep;
        // canvas.height /=scaleStep;
        // canvas.width /= realScaleStep;
        // canvas.height /= realScaleStep;
        canvas.width = minWidth * realScaleStep;
        canvas.height = minHeight * realScaleStep;
        scale = canvas.height / minHeight;
        ctx.scale(scale, scale);
        canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
        drawAllRect({ moveX: 0, moveY: 0});
        setScrollPositionCenter();
        callBack('zoomRatio', '当前比例&nbsp;&nbsp;&nbsp;' + realScaleStep * 100 + '%');
    }
    
    function revertRect(event) {
        realScaleStep = 1;
        canvas.width = minWidth;
        canvas.height = minHeight;
        scale = canvas.height / minHeight;
        ctx.scale(scale, scale);
        canvas.style.backgroundSize =`${canvas.width}px ${canvas.height}px`;
        drawAllRect({ moveX: 0, moveY: 0});
        setScrollPositionCenter();
    }

    function completeOperation(event) {
        let targetLayers = layers;
        // 针对于放大缩小，还原屏幕绘制的在图片位置的相对坐标
        if (scale !== 1) {
            targetLayers = resetRelativeRect(layers);
        }
        callBack('complete', calcRatioLayers(targetLayers));
    }

    function removeEvent() {
        canvas.removeEventListener("touchstart", touchStart);
        canvas.removeEventListener("touchmove", touchMove);
        canvas.removeEventListener("touchend", touchEnd);
        deleteImageBtn && deleteImageBtn.removeEventListener("click", toDeleteImage);
        editBtn && editBtn.removeEventListener("click", editRect);
        zoomInBtn && zoomInBtn.removeEventListener("click", zoomInRect);
        zoomOutBtn && zoomOutBtn.removeEventListener("click", zoomOutRect);
        revertBtn && revertBtn.removeEventListener("click", revertRect);
    }

    // 计算坐标在图片的真实位置
    function calcRatioLayers(calcLayers) {
        const calcResultLayers = calcLayers.map((val, index) => {
            // 按比例还原图片真实宽高
            // beginX: (val.beginX / canvas.width) * image.width,
            return {
                beginX: val.beginX * image.width / canvas.width,
                beginY: val.beginY * image.height / canvas.height,
                endX: val.endX * image.width / canvas.width,
                endY: val.endY * image.height / canvas.height
            }
        });
        return calcResultLayers;
    }

    // 还原图片的真实位置在canvas中的位置
    function calcCanvasPositionLayers(calcLayers) {
        const calcResultLayers = calcLayers.map((val, index) => {
            // 按比例还原图片真实宽高
            // beginX: (val.beginX / image.width) * canvas.width,
            return {
                ...val,
                beginX: (val.beginX / image.width) * canvas.width,
                beginY: (val.beginY / image.height) * canvas.height,
                endX: (val.endX / image.width) * canvas.width,
                endY: (val.endY / image.height) * canvas.height
            }
        });
        return calcResultLayers;
    }
    // 画矩形左边的数字
    function drawNumberBeforeRect(x, y, text, style) {
        let diffWidth = 0;
        let originWidth = 16; // 文字矩形宽度
        let originHeight = 10; // 文字矩形高度
        let textX= 3; // 文字位置X
        let textY = 8; // 文字位置Y
        x -= originWidth + diffWidth + 1; // 需要向矩形左边偏移
        y -= 1.5; // 矩形线条宽度 / 2
        if (text >= 100) {
            textX -= 2.5;
        } else if (text < 10) {
            textX += 2.5;
        }
        ctx.beginPath();
        style && (ctx.fillStyle = style);
        ctx.fillRect(x, y, originWidth + diffWidth, originHeight);
        ctx.fillStyle = '#ffffff';
        ctx.font = '8px "PingFangSC-Regular"';
        ctx.fillText(text, x + textX, y + textY);
        ctx.closePath();
    }
    // 画数字右边的矩形
    function drawRectAfterNumber(x, y, width, height, style) {
        ctx.beginPath();
        style && (ctx.strokeStyle = style);  // #1fcc23 绿色 #db8208 橙色
        ctx.strokeRect(x, y, width, height);
        ctx.closePath();
    }

    // 画出数组矩形
    function drawStokeRectArr(dataArr, style) {
        dataArr.forEach((val, index) => {
            drawRectAfterNumber(val.beginX, val.beginY, (val.endX - val.beginX), (val.endY - val.beginY), style);
        });
    }

    // 画数字以及挨着的矩形
    function drawMarkedNumberRect() {
        // 敏感信息标注
        drawStokeRectArr(sensitiveDatas, '#db8208');  // 橙色
        // ocr识别标注 以及数字
        recognizeDatas.forEach((val, index) => {
            drawRectAfterNumber(val.beginX - 1, val.beginY - 1, (val.endX - val.beginX + 2), (val.endY - val.beginY + 2), '#1fcc23'); // 绿色
            drawNumberBeforeRect(val.beginX, val.beginY, val.sort, '#1fcc23');
        });
        // drawStokeRectArr(recognizeDatas, '#1fcc23');
        // // 需要延时不然不能填充背景图片
        // recognizeDatas.forEach(val => {
        //     drawRect(val.beginX, val.beginY, (val.endX - val.beginX), (val.endY - val.beginY));
        // });
    }

    // 获取页面标注（绿色）
    function getOcrReconizeArea() {
        return new Promise((resolve, reject) => {
            let params = {
                formCode: formCode,
                imageUrl: [_imgUrl],
                // imgUrl: [_imgUrl]
                projectCode: itemData.projectCode,
                version: version
            }
            api.getOcrPositionSort(params).then(res => {
            // api.getDataOcrSort(params)
                // let _arr = (res && res.data) || [];
                // _arr = _arr.filter(val => {
                //     return !!val.coordinate;
                // });
                // _arr = _arr.map(val => {
                //     return {
                //         ...val.coordinate,
                //         sort: val.sort
                //     }
                // });
                const _data = res && res.data || [];
                resolve(_data);
            })
        });
    }

    function getSensitiveData () {
        return new Promise((resolve, reject) => {
            api.GetOcrSensitiveRecord({
                projectCode: itemData.projectCode,
                imgUrl: [_imgUrl]
            }).then(res => {
                const _obj = (res && res.data && res.data[0] && res.data[0]) || {};
                resolve(_obj);
            });
        });
    }

    function initMarkedArea() {
        if (isRecognize) {
            // ocr才需要进行ocr的逻辑
            if (isOcr) {
                if (cachesImgMap[_imgUrl] && cachesImgMap[_imgUrl].recognizeDatas) {
                    recognizeDatas = cachesImgMap[_imgUrl].recognizeDatas;
                    if (recognizeDatas && recognizeDatas.length > 0) {
                        drawMarkedNumberRect();
                    }
                } else {
                    let recognizeCount = 0;
                    let intervalCount = 0;
                    let maxRecognizeCount = 30;
                    let interDynamitCount = 1;
                    // 直接点进来，非上传后进来
                    if (!needOcrRecongize) {
                        maxRecognizeCount = 1; // 只调用一次
                    }
                    callBack('ocrReconize', 'init');
                    function recognizeRequest () {
                        if (recognizeCount < 10) {
                            intervalCount = intervalCount + 1;
                        }
                        // 
                        if (recognizeCount >= 10) {
                            interDynamitCount = 5;
                            intervalCount = intervalCount + 5;
                        }
                        if (intervalCount > maxRecognizeCount) {
                            // 超过30秒算完成
                            // 需要设置，不然没有数据再次进来还会轮询
                            if (_imgUrl && _imgUrl.indexOf('http') === 0) {
                                cachesImgMap[_imgUrl] = {
                                    ...cachesImgMap[_imgUrl],
                                    recognizeDatas
                                };
                            }
                            const msg = (recognizeDatas && recognizeDatas.length > 0) ? 'OCR识别完成' : 'OCR识别完成，未找到匹配字段';
                            callBack('ocrReconize', 'finish', msg);
                            recognizedArealdy = true;
                        }
                        recognizedArealdy && clearInterval(recognizeInterval);
                        !recognizedArealdy && getOcrReconizeArea().then(res => {
                            let msg = '';
                            // 识别完成 1识别完成，2识别失败，服务异常，4表单没有OCR识别字段
                            if ((res && res[0] && (res[0].code == 1)) || (res && res[0] && res[0].code == 4) || (res && res[0] && res[0].code == 2)) {
                                recognizedArealdy = true;
                                let arr = res;
                                arr = arr.filter(val => {
                                    return !!val.coordinate;
                                });
                                arr = arr.map(val => {
                                    return {
                                        ...val.coordinate,
                                        sort: val.sort
                                    }
                                });
                                if (arr && arr.length > 0) {
                                    recognizeDatas = calcCanvasPositionLayers(arr) || [];
                                    if (_imgUrl && _imgUrl.indexOf('http') === 0) {
                                        cachesImgMap[_imgUrl] = {
                                            ...cachesImgMap[_imgUrl],
                                            recognizeDatas
                                        };
                                    }
                                    drawMarkedNumberRect();
                                    msg =  'OCR识别完成';
                                } else if(res && res[0] && (res[0].code == 4)) {
                                    msg = res[0].msg || ''; // 表单没有OCR识别字段
                                } else {
                                    msg = 'OCR识别完成，未找到匹配字段';
                                }
                                callBack('ocrReconize', 'finish', msg);
                            }
                        });
                        recognizeCount++;
                        recognizeInterval && clearInterval(recognizeInterval);
                        if (!recognizedArealdy) {
                            recognizeInterval = setInterval(recognizeRequest, 1000 * interDynamitCount);
                        }
                    }
                    recognizeRequest();
                }
            }
            // 脱敏才需要敏感信息识别
            if (isEditPhoto) {
                let maxSenseCount = 30;
                // 直接点进来，非上传后进来
                if (!needOcrRecongize) {
                    maxSenseCount = 1;
                }
    
                if (sensitiveInitData && sensitiveInitData.length > 0) {
                    // 首次
                    sensitiveDatas = calcCanvasPositionLayers(sensitiveInitData);
                    drawMarkedNumberRect();
                } else if (cachesImgMap[_imgUrl] && cachesImgMap[_imgUrl].sensitiveDatas) {
                    // 缓存
                    sensitiveDatas = cachesImgMap[_imgUrl].sensitiveDatas;
                    if (sensitiveDatas && sensitiveDatas.length > 0) {
                        drawMarkedNumberRect();
                        callBack('showSensitive'); // 缓存更新，切换tab会有缓存导致敏感信息提示不更新
                    }
                } else  {
                    // 上传后，轮询查询
                    let sensitiveCount = 0;
                    let intervalCount = 0;
                    let interDynamitCount = 1;
                    function sensitiveRequest() {
                        if (sensitiveCount < 10) {
                            intervalCount = intervalCount + 1;
                        }
                        if (sensitiveCount >= 10) {
                            intervalCount = intervalCount + 5;
                            interDynamitCount = 5;
                        }
                        if (intervalCount > maxSenseCount) {
                            if (_imgUrl && _imgUrl.indexOf('http') === 0) {
                                cachesImgMap[_imgUrl] = {
                                    ...cachesImgMap[_imgUrl],
                                    sensitiveDatas
                                };
                            }
                            // 超过5秒算完成
                            sensitiveArealdy = true;
                        }
                        sensitiveArealdy && clearInterval(sensitiveInterval);
                        !sensitiveArealdy && getSensitiveData().then(res => {
                            let arr = (res && res.coordinate) || [];
                            const ocrCode = res.code; // 0、识别中，1、识别完成，2、识别失败，服务异常，3、该图片所属项目无识别
                            if (ocrCode == 1) {
                                sensitiveArealdy = true; // 识别完成，不需要继续调用接口了
                            }
                            if (arr && arr.length > 0) {
                                sensitiveDatas = calcCanvasPositionLayers(arr) || [];
                                if (_imgUrl && _imgUrl.indexOf('http') === 0) {
                                    cachesImgMap[_imgUrl] = {
                                        ...cachesImgMap[_imgUrl],
                                        sensitiveDatas
                                    };
                                }
                                drawMarkedNumberRect();
                                callBack('showSensitive', _imgUrl);
                                sensitiveArealdy = true;
                            }
                        });
                        sensitiveCount++;
                        sensitiveInterval && clearInterval(sensitiveInterval);
                        if (!sensitiveArealdy) {
                            sensitiveInterval = setInterval(sensitiveRequest, 1000 * interDynamitCount);
                        }
                    }
                    sensitiveRequest();
                }
            }

        }
    }

    // 定时终止
    function toClearInterval() {
        sensitiveArealdy = true;
        recognizedArealdy = true;
        recognizeInterval && clearInterval(recognizeInterval);
        sensitiveInterval && clearInterval(sensitiveInterval);
    }

    return {
        deleteTargetCover: deleteSelectRect,
        resetAllCover: resetAllCover,
        toClearInterval: toClearInterval
    }
}